import i18next from "i18next";

/**
 * The separator between the parts of a one-line summary ("Columns · 4 hidden").
 *
 * English keeps the spaced middle dot. Arabic uses the Arabic comma: next to
 * Arabic-Indic digits a middle dot reads as the digit zero («· ٤» looks like
 * «٤٠»). Translation bundles follow the same rule, and `pnpm i18n:check` keeps
 * the middle dot out of the Arabic ones.
 *
 * Defaults to the active UI language; pass `lang` when the text is rendered in
 * another one.
 */
export function metaSeparator(lang: string | null | undefined = i18next.language): string {
  return lang === "ar" || lang?.startsWith("ar-") === true ? "، " : " · ";
}
